export const MappingRequestResources = {
  en: {
    COMBINED_APPLICATION: "Please apply for combined application from My Page.",
  },
  jp: {
    COMBINED_APPLICATION: "ポイントの合算申請はマイページから行ってください。",
    COMBINED_APPLICATION_MORE: "乗務員番号の追加申請はマイページから行ってください。",
    APPROVAL_NOTICE:
      "※合算申請の承認は3営業日ほど要します。有効期限の近いポイントがある場合は早めの申請をお願いします。",
    AVAILABLE_DRIVER_NUMBER_NOTICE: "合算申請可能な乗務員番号があります。申請を行うと保有ポイントを合算できます。",
    ABOUT_POINT_COMBINED_APPLICATION: "ポイントの合算申請について",
    BUSINESS_NAME: "事業者名",
    SALES_OFFICE_NAME: "営業所名",
    APPLY_FOR_COMBINED_APPLICATION: "合算申請する",
    UNAPPLIED: "未申請",
    REVIEWING: "審査中",
    APPROVED: "合算済み",
    REJECTED: "却下",
    REVOKE: "解除",
    REVOKE_CREW_NOTICE_TITLE: "この乗務員番号を解除してもよろしいですか？",
    REVOKE_CREW_NOTICE_0: "解除前に必ずご確認ください",
    REVOKE_CREW_NOTICE_1: "解除すると、この乗務員番号での配車での獲得ポイントが合算されなくなります。",
    REVOKE_CREW_NOTICE_2: "再度、合算申請するには乗務員アプリからやり直しが必要です。",
    REVOKE_CREW_NOTICE_3: "詳細については「ポイントの合算解除について」をご確認ください。",
    DO_REVOKE: "解除する",
    SUCCESSFULLY_REVOKED: "解除しました。",
    FAILED_TO_REVOKE: "解除できませんでした。",
    APPLICATION_FOR_POINT_COMBINATION: "ポイントの合算申請",
    PIN_CODE_SENT_TO_SMS_EXMAPLE_FOR_POINT_COMBINED_APPLICATION:
      "乗務員アプリから携帯電話番号のSMS(メッセージ)へ送信された認証コード4桁の数字を24時間以内に入力してください。",
    WHAT_IS_POINT_COMBINATION: "ポイントの合算申請とは何ですか?",
    WHAT_IS_REVOKE_POINT_COMBINATION: "ポイントの合算解除について",
    POINT_COMBINED_APPLICATION_ACCEPTED: "ポイントの合算申請を受け付けました",
    POINT_COMBINED_APPLICATION_ACCEPTED_MESSAGE:
      "GO株式会社にて内容確認を行いますので完了するまでお待ちください。\n申請状況は登録のメールアドレス宛てに連絡いたします。",
    POINT_COMBINED_APPLICATION_EXECUTED: "ポイント合算",
    POINT_COMBINED_APPLICATION_REVERTED: "ポイント合算取消",
    POINT_COMBINED_APPLICATION_REVERTED_FROM: "乗務員番号【%s】からの合算取消",
    POINT_COMBINED_APPLICATION_EXECUTED_FROM: "乗務員番号【%s】より合算",
    POINT_COMBINED_APPLICATION_EXECUTED_TO: "乗務員番号【%s】への合算取消",
    POINT_COMBINED_APPLICATION_REVERTED_TO: "乗務員番号【%s】へ合算",
    MOVE: "移行",
  },
};
